export default __webpack_public_path__ + "static/media/General's Gauntlets of the Battlements.e8c5b237.jpg";